<nb-card>
  @if (title || subtitle) {
    <nb-card-header>
      @if (title) {
        <h1>{{ title | translate }}</h1>
      }
      @if (subtitle) {
        <h3>{{ subtitle }}</h3>
      }
    </nb-card-header>
  }
  <nb-card-body [nbSpinner]="!this.instance || this.instance.isLoading">
    <div #container>

    </div>
  </nb-card-body>
  <nb-card-footer>
    @if (footer) {
      <ng-container [ngTemplateOutlet]="footer" [ngTemplateOutletContext]="{popup: this}"></ng-container>
    }
    @if (!footer) {
      <button nbButton (click)="done(instance)">{{ 'close' | translate }}</button>
    }
  </nb-card-footer>
</nb-card>
